import { lazy } from "react";
import Loadable from "app/components/Loadable";
import Supplements from "../supplements";

const supplements = Loadable(lazy(() => import("../supplements")));

const SupplementsRoute = [{ path: "/supplements", element: <Supplements /> }];
export default SupplementsRoute;
